import Vue from "vue";
/* 表单验证 */
import formRules from "./formRules";
import QRCode from "qrcodejs2";

/* 组件封装 */
import "@/components/components.js";
/* 创建弹出框 */
import { requestAxios, requestAxiosForm } from "@/apis/http";

import createDialog from "@/components/dialog/createDialog.js";
// 请求封装
import "@/apis/http.js";
import { MessageBox } from "element-ui";
import { Message } from "element-ui";
/* http://192.168.9.245:8003/asset */
/* 登陆页logo替换 */

let global = {
  // baseURL: "http://erp.xikongeas.com:8866/asset", //请求地址 --如果urlSetting=true 这个值必须为空字符串
  // baseURL: "http://erp.xikongeas.com:8866/asset",
   baseURL: "http://140.143.85.89/asset", //请求地址 --如果urlSetting=true 这个值必须为空字符串
   //请求地址 --如果urlSetting=true 这个值必须为空字符串
  urlSetting: true, //是否显示地址栏配置,这个为true baseURL必须为空
  appDown: false, //是否显示首页的app下载
  mobileLogin: true, //是否允许使用手机号登陆
/*
wetherGoodsStatistics
true 是调取新的接口  所属组织统计(%)变为物资统计 再家一个更多按钮  弹出显示所有  分页 17 -1  2023-12-6  
  false 原界面不变   遂宁武警支队用true
*/
  wetherGoodsStatistics: true,

  copyright: "版权所有：成都希柯科技有限公司",
  power: "5", //读写器默认功率，不设置则为26
  loginHeader:  require('@/assets/images/logon_logo2--asset.png'),
  homeLogo: require('@/assets/images/logon.png') ,
};

/* 
本地写个变量 用来判断是否调取新的接口  true则不变  
FALSE 是调取新的接口  所属组织统计(%)变为物资统计 再家一个更多按钮  弹出显示所有  分页 17 -1

新增出入记录 接口23


*/

if (!global.baseURL && global.urlSetting) {
  let v = JSON.parse(localStorage.getItem("systemSetting"));
  if (v) {
    global.baseURL = "";

    let { url, agreement, port, serveName } = v;
    global.baseURL = agreement + url;
    if (port) {
      global.baseURL += ":";
      global.baseURL += port;
    }
    if (serveName) {
      global.baseURL += "/";
      global.baseURL += serveName;
    }
  } else {
    localStorage.setItem(
      "asset-urlSetting",
      "http://" + window.location.hostname
    );
    global.baseURL = "http://" + window.location.hostname + ":8003/asset";
  }
} else {
  localStorage.removeItem("systemSetting");
}

let alertMsg = {
  /**
   * 警告提示
   * @param warning 提示内容
   * @param thenFun    确认调用方法
   * @param catchFun   取消调用方法
   */
  confirm: function(
    warning,
    thenFun,
    catchFun = (action) => {
      Message({
        type: "info",
        message: action === "cancel" ? "已取消操作" : action,
      });
    }
  ) {
    MessageBox.confirm(warning, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    })
      .then(() => {
        if (thenFun) {
          thenFun();
        }
      })
      .catch((action) => {
        if (catchFun) {
          catchFun(action);
        }
      });
  },
};

function success(msg, type) {
  Message({
    message: msg ? msg : "操作成功!",
    type: type ? type : "success",
  });
}

function getCurrentDate() {
  let date = new Date();

  let year = date.getFullYear();

  let month =
    date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1;
  let day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
  let hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  let minute =
    date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  let second =
    date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  let currentdate = `${year}-${month}-${day}`;
  return currentdate;
}

function axiosDelete(url, data, init, params, axiosType, title) {
  alertMsg.confirm(title ? title : "确定进行删除吗", () => {
    if (axiosType) {
      requestAxios(
        {
          url,
          data,
        },
        () => {
          Message({
            message: "操作成功!",
            type: "success",
          });
          init(params);
        }
      );
    } else {
      requestAxiosForm(
        {
          url,
          data,
        },
        () => {
          Message({
            message: "操作成功!",
            type: "success",
          });
          init(params);
        }
      );
    }
  });
}

/* 表单验证 */
function formValidate(_this, ref) {
  let p = new Promise((resove, reject) => {
    _this.$refs[ref].validate((valid) => {
      if (valid) {
        resove();
      }
    });
  });
  return p;
}

/* 数组扁平 */
function arrflat(arr, result) {
  for (let i = 0; i < arr.length; i++) {
    result.push(arr[i]);
    if (arr[i].children && arr[i].children.length) {
      arrflat(arr[i].children, result);
    }
  }
  return result;
}

//递归处理空的children
function treeChildrenEmp(arr) {
  arr.forEach((item) => {
    if (item.children == [] || item.children == "") {
      delete item.children;
    }
    if (item.children && item.children.length) {
      treeChildrenEmp(item.children);
    }
  });
}

var timer = null;
var flag = false;

function throttle(func, wait = 300, immediate = true) {
  if (immediate) {
    if (!flag) {
      flag = true;
      // 如果是立即执行，则在wait毫秒内开始时执行
      typeof func === "function" && func();
      timer = setTimeout(() => {
        flag = false;
      }, wait);
    }
  } else {
    if (!flag) {
      flag = true;
      // 如果是非立即执行，则在wait毫秒内的结束处执行
      timer = setTimeout(() => {
        flag = false;
        typeof func === "function" && func();
      }, wait);
    }
  }
}

function dynamicColor(data) {
  let color = "color:#67C23A";
  switch (data) {
    case "无扫描器":
      color = "color:#E6A23C";
      break;
    case "连接断开":
      color = "color:#F56C6C";
      break;
    case "已连接":
      color = "color:#67C23A";
      break;
    case "连接失败":
      color = "color:rgb(245, 108, 108)";
      break;
  }
  return color;
}

Vue.prototype.barcode_monitor = function(callBack) {
  /* 取需要的Code  */
  function codeFilter(keyCode) {
    if (
      (keyCode >= 48 && keyCode <= 57) ||
      (keyCode >= 96 && keyCode <= 105) ||
      (keyCode >= 65 && keyCode <= 90)
    ) {
      return String.fromCharCode(keyCode);
    } else {
      return "";
    }
  }
  let codeArr = [];
  let code = "";
  document.onkeypress = function(e) {
    console.log(e);
    let keyCode = e.which || e.keyCode;
    if (codeArr.length) {
      if (new Date().getTime() - codeArr[codeArr.length - 1].time <= 100) {
        if (keyCode == 13) {
          console.log("最后结果", code);
          callBack(code);
          codeArr = [];
          code = "";
        } else {
          if (e.key.length == 1) {
            code += e.key;
          }
          codeArr.push({
            keyCode,
            code: codeArr[codeArr.length - 1].code + codeFilter(keyCode),
            time: new Date().getTime(),
          });
        }
      } else {
        code = "";
        codeArr = [];
        if (e.key.length == 1) {
          code += e.key;
        }
        codeArr.push({
          keyCode,
          code: codeFilter(keyCode),
          time: new Date().getTime(),
        });
      }
    } else {
      if (e.key.length == 1) {
        code += e.key;
      }
      codeArr.push({
        keyCode,
        code: codeFilter(keyCode),
        time: new Date().getTime(),
      });
    }
  };
  /*  document.onkeypress = function(e) {
      
      nextCode = e.which || e.keyCode;
      nextTime = new Date().getTime();
      if (lastCode != null && lastTime != null && nextTime - lastTime <= 100) {
        // 扫码枪
        code += String.fromCharCode(lastCode);
      } else if (
        lastCode != null &&
        lastTime != null &&
        nextTime - lastTime > 100
      ) {
        // 键盘
        console.log("键盘输入", String.fromCharCode(lastCode));
        code = "";
      }

      lastCode = nextCode;
      lastTime = nextTime;
      if (e.which == 13) {
        callBack(code)
        console.log("执行了一次enter扫码枪数据：" + code);
        code = "";

        e.preventDefault();
        //下方使用你要调用的方法
      }
    }; */
};
/* 二维码转为图片 */
function codeImg(
  options = {
    width: 100,
    height: 100,
    text: "abc12345",
  }
) {
  let dom = document.createElement("div");
  dom.id = "codeImg2";
  let qrcode = new QRCode(dom, options);
  let c = dom.children[1];
  let p = new Promise((resolve, reject) => {
    setTimeout(() => {
      if (c.src) {
        resolve(c.src);
      } else {
        reject();
      }
    });
  });

  return p;
}
Vue.prototype.$codeImg = codeImg;
Vue.prototype.$getCurrentDate = getCurrentDate;
Vue.prototype.$arrflat = arrflat;
Vue.prototype.$dynamicColor = dynamicColor;
Vue.prototype.$throttle = throttle;
Vue.prototype.$formValidate = formValidate;
Vue.prototype.$success = success;
Vue.prototype.$axiosDelete = axiosDelete;
Vue.prototype.$alertMsg = alertMsg;
Vue.prototype.$global = global;
Vue.prototype.$treeChildrenEmp = treeChildrenEmp;

Vue.prototype.formRules = formRules;
Vue.prototype.$createDialog = createDialog;
export default global;
